import Config from '../config.json';

export const logout = () => {
  window.addToDataLayer('profilemenu', 'logout');
  localStorage.clear();
  sessionStorage.clear();
  window.location.replace(Config.navHomePath);
};
